import { Button } from "react-bootstrap";

import { ServiceOrderType } from "@/_constants/serviceOrder.ts";
import DiagnosticCardComponent from "@/common/components/DiagnosticCardComponent.tsx";
import NewDPE from "@/common/components/NewDPEComponent";
import { DataDwellingInfos } from "@/modules/dwelling/interfaces";
import { IDwelling } from "@/modules/dwelling/reducers";
import { SERVICE_ORDERING } from "@/modules/serviceOrdering/routes/ServiceOrderingRoutes.ts";
import { useServiceInventoryStore } from "@/modules/serviceOrdering/store/ServiceInventoryStore.ts";
import history from "@/routes/history.ts";

import FilesDataGrid from "./FilesDataGrid.tsx";

const DwellingDiagnostic = ({ dwelling }: { dwelling: DataDwellingInfos }) => {
  const data: DataDwellingInfos["diagnostics"] = dwelling.diagnostics;
  const setAddressFilter = useServiceInventoryStore(
    (state) => state.setAddressFilter,
  );
  const setSelectedAddress = useServiceInventoryStore(
    (state) => state.setSelectedAddress,
  );
  const setCurrentForm = useServiceInventoryStore(
    (state) => state.setCurrentForm,
  );
  return (
    <div className="d-flex flex-column gap-3">
      <div className="bg-container d-flex flex-column gap-4">
        <div className="d-flex justify-content-between align-items-center">
          <span className="dwelling_title">Diagnostics</span>
          <div className="d-flex gap-3">
            <Button
              className="btn dwelling_property-button_edit"
              onClick={() => {
                setSelectedAddress(dwelling as unknown as IDwelling);
                setAddressFilter("");
                setCurrentForm(ServiceOrderType.DIAGNOSTIC);
                history.push(SERVICE_ORDERING);
              }}
            >
              <i className="bi bi-cart2"></i>
            </Button>
          </div>
        </div>

        <div className="diagnostics-container">
          {Object.keys(data).length > 0 ? (
            <div className="diagnostics">
              {data?.EPD && (
                <DiagnosticCardComponent
                  title="DPE"
                  isDataNotEmpty={Object.keys(data.EPD).length > 0}
                  result={
                    <NewDPE
                      params={{
                        dpe: data.EPDLabel2020,
                        active: true,
                      }}
                    />
                  }
                  date={data.EPD.energy.validityDate}
                />
              )}
              {data?.asbestos && (
                <DiagnosticCardComponent
                  isDataNotEmpty={Object.keys(data.asbestos).length > 0}
                  title="Amiante"
                  result={
                    <p>{data.asbestos.isPresent ? "Présence" : "Absence"}</p>
                  }
                  hasIssue={data.asbestos.isPresent}
                  date={data.asbestos.validityDate}
                />
              )}
              {data?.lead && (
                <DiagnosticCardComponent
                  isDataNotEmpty={Object.keys(data.lead).length > 0}
                  title="Plomb"
                  result={<p>{data.lead.isPresent ? "Présence" : "Absence"}</p>}
                  hasIssue={data.lead.isPresent}
                  date={data.lead.validityDate}
                />
              )}
              {data?.area?.living ? (
                <DiagnosticCardComponent
                  isDataNotEmpty={data.area.living > 0}
                  title="Surface habitable"
                  result={<p>{data.area.living}</p>}
                />
              ) : null}
              {data?.electricity && (
                <DiagnosticCardComponent
                  isDataNotEmpty={Object.keys(data.electricity).length > 0}
                  title="Sécurité Électrique"
                  result={
                    <p>
                      {data.electricity.hasIssue
                        ? "Anomalies détectées"
                        : "Aucune anomalies détectées"}
                    </p>
                  }
                  hasIssue={data.electricity.hasIssue}
                  date={data.electricity.validityDate}
                />
              )}
              {data?.gas && (
                <DiagnosticCardComponent
                  isDataNotEmpty={Object.keys(data.gas).length > 0}
                  title="Sécurité Gaz"
                  result={
                    <p>
                      {data.gas.hasIssue
                        ? "Anomalies détectées"
                        : "Aucune anomalies détectées"}
                    </p>
                  }
                  hasIssue={data.gas.hasIssue}
                  date={data.gas.validityDate}
                />
              )}
            </div>
          ) : (
            <p className="p-no-property mt-3 ms-2">Aucun diagnostic</p>
          )}

          <div className="files-data-grid">
            <FilesDataGrid id={dwelling.id} files={data?.files} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DwellingDiagnostic;
